export default "__VITE_ASSET__i$r6Pwgt__"